import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  allnews: [],
  // news: {},
  category: [],
  categoryById: {},
  news: false,
  loading: false,
  formLoading: false,
  exportLoading: false,
  exportSuccess: false,
  error: false,
  categoryError: false,
  success: false,
  preventNew: false,
  paging: false,
  downloadLink: '',
  accountsWithTotal: false,
  newsCreated: 0,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/News/index.js